import {
  fetchPostTruelayerBankAuthenticationUrl,
  PostTruelayerBankAuthenticationUrlResponse,
} from '@iwoca/lapi-client/edge';
import { useMutation } from '@tanstack/react-query';

type TruelayerBankAuthenticationVariables = {
  stateKey: string;
  providerId: string;
};

export function useTruelayerAuthorizationMutation() {
  const { mutate, isPending, data, reset, isError } = useMutation<
    PostTruelayerBankAuthenticationUrlResponse,
    Error,
    TruelayerBankAuthenticationVariables
  >({
    mutationFn: ({ stateKey, providerId }) => {
      return fetchPostTruelayerBankAuthenticationUrl({
        stateKey,
        providerId,
      });
    },
  });

  return {
    postBankAuthentication: mutate,
    isPending,
    bankAuthUrl: data?.data.bank_url,
    isError,
    resetURL: reset,
  };
}
